// Fake id used because we can only access the current user context
export const CurrentUserId = 'layer7@currentUser';
